export var QueryParamName;
(function (QueryParamName) {
    QueryParamName["UNITS_QUERY_PARAM"] = "units";
    QueryParamName["PARTNER_QUERY_PARAM"] = "partnerName";
})(QueryParamName || (QueryParamName = {}));
